module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":"Home","skus":"Prices","about":"About","logout":"Sign Out"},"es":{"home":"Hogar","skus":"Precios","about":"Acerca de","logout":"Desconectar"},"sw":{"home":"Nyumbani","skus":"Bei","about":"Kuhusu","logout":"Ondoka"}}')
  delete Component.options._Ctor
}
